import { OverviewPage } from "@/features/overview/overview-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/")({
  component: OverviewPage,
});
